/* ==========================================================
   PREMIUM FX — Honeycomb Loader
   Bees & Bear
   ========================================================== */
(function () {
  "use strict";

  document.addEventListener("DOMContentLoaded", initHoneycombLoader);

  // The color-chase animation loops continuously and has no fixed end
  // point, so there's nothing to "finish" before hiding — real timing is
  // simply: show until DOMContentLoaded (the point the page is actually
  // parsed and usable), then hide. No artificial delay.
  function initHoneycombLoader() {
    var loader = document.getElementById("premium-loader");
    if (!loader) return;
    loader.classList.add("is-hidden");
  }
})();